const defaultTextColor = "#343f51";
const defaultBackgroundColor = "#ffffff";
const defaultBackgroundColorHover = "#f6f6f6";
const defaultBorderColor = "#9b9b9b";
const defaultColor = "#ffffff";
const defaultColorHover = "#f6f6f6";
const primaryTextColor = "#ffffff";
const primaryColor = "#015aa0";
const primaryBorderColor = "#0079d9";
const primaryColorHover = "#014d89";
const disabledColor = "#f3f2f1";
const disabledTextColor = "#aaa8a7";
const negativeColor = "#a94442";
const negativeColorHover = "#903937";
const alternateBorderColor = "#eaeaea";
const defaultFontFamily = "Segoe UI, Segoe UI Web (West European), Segoe UI, -apple-system, BlinkMacSystemFont, Roboto,Helvetica Neue, sans-serif";
export {
  alternateBorderColor,
  defaultBackgroundColor,
  defaultBackgroundColorHover,
  defaultBorderColor,
  defaultColor,
  defaultColorHover,
  defaultFontFamily,
  defaultTextColor,
  disabledColor,
  disabledTextColor,
  negativeColor,
  negativeColorHover,
  primaryBorderColor,
  primaryColor,
  primaryColorHover,
  primaryTextColor
};
//# sourceMappingURL=theme.js.map
